import React, { useContext, useState } from 'react';
import { FaBookmark, FaRegBookmark } from 'react-icons/fa';
import { FormContext } from '../../pages/CMSRenderer/CMSRenderer';

const List = ({
  icon,
  title = "",
  subtitle = "",
  onViewDetails,
  onApply,
  bookmarked = false,
  onBookmark,
  showApplyButton = true,
}) => {
  const { currentLang } = useContext(FormContext);
  const [isBookmarked, setIsBookmarked] = useState(bookmarked);

  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
    if (onBookmark) onBookmark(!isBookmarked);
  };

  return (
    <div className="flex justify-between items-center border-b border-outlineVariant pb-4 gap-4 flex-wrap md:flex-nowrap">
      <div className="md:flex items-start md:items-center gap-3 flex-1 w-full md:w-2/3">
        {icon}
        <div>
          <p className="body">{title}</p>
          <p dangerouslySetInnerHTML={{ __html: subtitle }} className="caption text-onSurfaceVariant"></p>
        </div>
      </div>

      <div className="flex items-center gap-3 w-full md:w-1/3 justify-end md:justify-between">
        <div className="flex gap-2 flex-1 md:flex-none">
          <dda-button
            button_color="default-tertiary"
            button_text={currentLang === 'en' ? 'View Details' : 'عرض التفاصيل'}
            custom_class="min-w-[110px] w-full md:w-auto"
            onclick={onViewDetails}
          ></dda-button>

          {showApplyButton && (
            <dda-button
              button_color="default-primary"
              button_text={currentLang === 'en' ? 'Apply' : 'تقديم'}
              custom_class="min-w-[110px] w-full md:w-auto"
              onclick={onApply}
            ></dda-button>
          )}
        </div>

        <button
          className="p-2 hover:bg-surfaceVariant/50 rounded-full transition-colors"
          onClick={handleBookmark}
          aria-label="Bookmark"
        >
          {isBookmarked ? (
            <FaBookmark className="text-primary text-2xl" />
          ) : (
            <FaRegBookmark className="text-primary text-2xl" />
          )}
        </button>
      </div>
    </div>
  )
}

export default List